import { Box } from "@mui/material";
import Head from "next/head";
import Breadcrumbs from "../src/components/common/Breadcrumbs";

import { MemoizedFooter } from "../src/layouts/footer";
import { MemoizedHeader } from "../src/layouts/header";
import BookVehicleDrawer from "../src/modules/Home/Drawer/bookVehicleDrawer";
import TCOPage from "../src/pages/TCO/TCO";

const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Total Cost of Ownership" },
];

const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Total Cost of Ownership",
      item: "https://www.turno.club/total-cost-of-ownership",
    },
  ],
};

export default function EnquiryPage() {
  return (
    <>
      <Head>
        <title>
          Turno.club - Want to know more on buying your commercial EV, Turno is
          the one-stop-destination for you
        </title>
        <meta
          name="description"
          content="Get the best loan offer on commercial three wheeler electric loading or electirc auto in India with Turno. Get a free test drive and book your electric vehicle today. Turno provides the best solution to buy EVs in India. Get a wide range of EVs available on turno.club with best price in India."
        />
        <meta
          name="keywords"
          content="Turno, Electric Vehicle ownership, total cost of ownership calculator, ICE Vs EV comparison"
        />
        <meta name="author" content="Turno" />
        <meta
          name="url"
          content="https://www.turno.club/total-cost-of-ownership"
        />

        <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
        <meta name="lang" content="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Facebook */}
        <meta
          property="og:url"
          content="https://www.turno.club/total-cost-of-ownership"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Turno.club - Want to know more on buying your commercial EV, Turno is
          the one-stop-destination for you"
        />
        <meta
          property="og:description"
          content="Get the best loan offer on commercial three wheeler electric loading or electirc auto in India with Turno. Get a free test drive and book your electric vehicle today. Turno provides the best solution to buy EVs in India. Get a wide range of EVs available on turno.club with best price in India."
        />
        <meta property="og:image" content="/logoIcon.png" />
        <meta property="fb:app_id" content="5796260583761767" />
        <meta property="fb:pages" content="646488286564232" />
        {/* Twitter */}
        <meta
          name="twitter:description"
          content="Get the best loan offer on commercial three wheeler electric loading or electirc auto in India with Turno. Get a free test drive and book your electric vehicle today. Turno provides the best solution to buy EVs in India. Get a wide range of EVs available on turno.club with best price in India."
        />
        <meta
          name="twitter:title"
          content="Turno.club - Want to know more on buying your commercial EV, Turno is
          the one-stop-destination for you"
        />
        <meta name="twitter:site" content="@Turno" />
        <meta name="twitter:creator" content="@Turno" />
        <meta
          name="twitter:url"
          content="https://www.turno.club/total-cost-of-ownership"
        />
        <meta
          name="twitter:app:id:googleplay"
          content="com.customerapp.turno.turno_customer_application"
        />
        <meta name="twitter:app:country" content="IN" />

        <link
          rel="canonical"
          href="https://www.turno.club/total-cost-of-ownership"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(BREADCRUMB_SCHEMA),
          }}
          defer
        />
      </Head>
      <Box style={{ maxWidth: "480px", margin: "0px auto" }}>
        <MemoizedHeader />
        <BookVehicleDrawer />
        <TCOPage />
        <Box sx={{ width: { xs: "100%", md: "84%" }, margin: "20px auto", padding: { xs: "0 12px", md: "0" } }}>
          <Breadcrumbs items={BREADCRUMB_ITEMS} />
        </Box>
        <MemoizedFooter />
      </Box>
    </>
  );
}
